var map = {
	"./assets/image/sgtest/expired/bg.png": "46aa",
	"./assets/image/sgtest/result/kurisu/bg.png": "b2c0",
	"./assets/image/sgtest/result/mayuri/bg.png": "71b2",
	"./assets/image/sgtest/result/rintarou/bg.png": "c814",
	"./assets/image/sgtest/result/suzuha/bg.png": "0bd2",
	"./assets/image/survey/expired/bg.png": "cbd9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3c72";